<script>
export default {
  name: 'AddCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99992 1.33301C4.32659 1.33301 1.33325 4.32634 1.33325 7.99967C1.33325 11.673 4.32659 14.6663 7.99992 14.6663C11.6733 14.6663 14.6666 11.673 14.6666 7.99967C14.6666 4.32634 11.6733 1.33301 7.99992 1.33301ZM10.6666 8.49967H8.49992V10.6663C8.49992 10.9397 8.27325 11.1663 7.99992 11.1663C7.72658 11.1663 7.49992 10.9397 7.49992 10.6663V8.49967H5.33325C5.05992 8.49967 4.83325 8.27301 4.83325 7.99967C4.83325 7.72634 5.05992 7.49967 5.33325 7.49967H7.49992V5.33301C7.49992 5.05967 7.72658 4.83301 7.99992 4.83301C8.27325 4.83301 8.49992 5.05967 8.49992 5.33301V7.49967H10.6666C10.9399 7.49967 11.1666 7.72634 11.1666 7.99967C11.1666 8.27301 10.9399 8.49967 10.6666 8.49967Z"
      :fill="color"
    />
  </svg>
</template>
